<template lang="pug">
  .container-listagem
    el-row
      el-col
        Pesquisa(
          placeHolder = "Informe o nome da Gleba, município ou nº do Processo",
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
          :hasPesquisaAvancada="false",
          @searchAdvanced="handlePesquisaAvancada"
        )
          template(slot="pesquisaAvancada")
            pesquisa-avancada-arrecadacao(
              :filtro="pesquisaAvancada"
            )

    el-card.default-card(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de Processos",
        @click="resetPesquisa",
        :hasButton="true"
        content="Atualizar processos"
      )

      table-generica(
        :colunas="colunas",
        :botoesAcao="botoesAcao",
        :sortChanged='sortChanged',
        :dados='processosCadastrados'
        )

      app-paginacao(
        :total="totalCadastros"
        :pagina="pagina",
        @changePage="changePage"
      )
</template>

<script>
import { mapActions } from 'vuex'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
import cloneDeep from 'lodash/cloneDeep'
import PesquisaAvancadaArrecadacao from '@/screens/arrecadacao/components/PesquisaAvancadaArrecadacao'
import TableGenerica from '@/components/TableGenerica'
import STATUS from '@/constants/statusProcessoArrecadacao'
import AppNotificacao from '@/components/mixins/AppNotificacao'

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  withStatus: [
    STATUS.AGUARDANDO_GERACAO_DOCUMENTOS,
    STATUS.AGUARDANDO_VALIDACAO_CADASTRO,
    STATUS.AGUARDANDO_VALIDACAO_RETIFICACAO,
    STATUS.VALIDACAO_EM_ANDAMENTO,
    STATUS.VALIDACAO_RETIFICACAO_EM_ANDAMENTO
  ]
}

const PESQUISA_AVANCADA_EMPTY = {
  numeroProcesso: null,
  gleba: null,
  municipio: null,
  status: null
}

export default {
  data () {
    return {
      processosCadastrados: [],
      totalCadastros: 0,
      filtro: cloneDeep(FILTRO_EMPTY),
      pesquisaAvancada: cloneDeep(PESQUISA_AVANCADA_EMPTY),
      colunas: [
        {
          prop: 'usuario.pessoa.pessoaFisica.nome',
          label: 'Responsável',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'numeroProcesso',
          label: 'Processo',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.gleba',
          label: 'Gleba',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'dataCriacao',
          label: 'Data',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'cadastroColetivo.pecaTecnica.municipios[0].nome',
          label: 'Município',
          width: 'auto',
          formatter: Utils.formatEmptyRow,
          sortable: 'custom'
        },
        {
          prop: 'statusName',
          label: 'Situação',
          formatter: Utils.formatEmptyRow,
          width: 'auto',
          sortable: 'custom'
        }
      ]
    }
  },

  components: {
    AppPaginacao,
    AppDividerRefreshButton,
    TableGenerica,
    Pesquisa,
    PesquisaAvancadaArrecadacao
  },

  mixins: [AppNotificacao],

  computed: {
    pagina () {
      return this.filtro.pagina + 1
    }
  },

  methods: {
    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getProcessosCadastrados(this.filtro)
    },

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.changePage(1)
    },

    handlePesquisa (value) {
      if (value) {
        this.filtro.pesquisaSimples = value
        this.filtro.simplificado = true
        this.getProcessosCadastrados()
      }
    },

    handlePesquisaAvancada () {
      this.setFiltroAdvancedSearch()
      this.handlePesquisa()
    },

    botoesAcao (processo) {
      if (processo.status === 'AGUARDANDO_GERACAO_DOCUMENTOS') {
        return [
          {
            click: () => {},
            icon: 'warning',
            title: 'Aguardando geração de documentos',
            active: true
          }
        ]
      } else if (processo.status === 'VALIDACAO_EM_ANDAMENTO') {
        return [
          {
            click: this.analisarProcesso.bind(this, processo),
            icon: 'check',
            title: 'Continuar Validação',
            active: true
          },
          {
            click: this.deletar.bind(this, processo),
            icon: 'delete',
            title: 'Deletar Processo',
            active: true
          }
        ]
      } else {
        return [
          {
            click: this.analisarProcesso.bind(this, processo),
            icon: 'check',
            title: 'Validar Processo',
            active: true
          },
          {
            click: this.deletar.bind(this, processo),
            icon: 'delete',
            title: 'Deletar Processo',
            active: true
          }
        ]
      }
    },

    async deletar (processo) {
      this.confirmBox(
        this.$messages.MSG_CONFIRMACAO,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteById(processo.id).then(() => {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.DELETE
            )
            this.getProcessosCadastrados()
          })
        },
        () => {}
      )
    },

    setFiltroAdvancedSearch (pesquisaSimples) {
      this.filtro.nome = pesquisaSimples || this.pesquisaAvancada.nome

      if (this.pesquisaAvancada.numeroProcesso) {
        this.filtro.numeroProcesso = this.pesquisaAvancada.numeroProcesso
      }

      if (this.pesquisaAvancada.gleba) {
        this.filtro.gleba = this.pesquisaAvancada.gleba
      }

      if (this.pesquisaAvancada.municipio) {
        this.filtro.municipio = this.pesquisaAvancada.municipio
      }

      if (this.pesquisaAvancada.status) {
        this.filtro.status = this.pesquisaAvancada.status
      }
    },

    async changePage (newPage) {
      this.filtro.pagina = newPage - 1
      await this.getProcessosCadastrados()
    },

    async analisarProcesso (processo) {
      if (processo.status === 'AGUARDANDO_VALIDACAO_CADASTRO' || processo.status === 'AGUARDANDO_VALIDACAO_RETIFICACAO') {
        await this.tramitarValidacao(processo.id)
      }
      const processoArrecadacao = await this.findByIdCompleto(processo.id)
      const cadastro = await this.findByIdCadastroColetivo(processoArrecadacao.cadastroColetivo.id)
      this.$router.push({
        name: 'gat/validacaoCadastro',
        query: {
          idProcesso: processo.id,
          modulo: 'gat'
        },
        params: {
          cadastroColetivo: cadastro
        }
      })
    },

    async getProcessosCadastrados () {
      const data = await this.findProcessosCadastrados(this.filtro)
      this.processosCadastrados = data.processosArrecadacao
      this.totalCadastros = data.total
    },

    ...mapActions({
      tramitarValidacao: 'processoArrecadacao/tramitarValidacao',
      findProcessosCadastrados: 'processoArrecadacao/find',
      deleteById: 'processoArrecadacao/deleteById',
      findByIdCadastroColetivo: 'cadastroColetivo/findById',
      findByIdCompleto: 'processoArrecadacao/findByIdCompleto'
    })
  },

  created () {
    this.getProcessosCadastrados(this.filtro)
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/GatAguardandoValidacao.vue